export default __webpack_public_path__ + "static/media/downloadicon.b25677df.svg";